import { Typography } from '@mui/material'
import { C1CircularProgress } from 'c1ui/components/C1CircularProgress/C1CircularProgress'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Minus } from 'lucide-react'
import { SearchAttributeValuesRequest } from 'pbts/c1/api/attribute/v1/attribute'
import { FormattedMessage } from 'react-intl'
import { searchAttributeValuesApi } from 'redux_toolkit/entitlements'

type AttributeValueDisplayWithFetchProps = {
    req: SearchAttributeValuesRequest
}
export const AttributeValueDisplayWithFetch = ({ req }: AttributeValueDisplayWithFetchProps): React.ReactElement => {
    const {
        data,
        isError,
        error,
        isLoading,
    } = searchAttributeValuesApi.useSearchAttributeValues(req)

    if (isLoading) {
        return <C1CircularProgress size={12} />
    }

    if (isError && error) {
        console.error(error)
        return <Typography color="error">
            <FormattedMessage id="component_api_error_entitlement" defaultMessage="Error fetching attribute" />
        </Typography>
    }

    return <>
        {
            data.flat().length > 0
                ? data.flat().map((attr) => <Typography key={attr.id}>{attr.value}</Typography>)
                : <C1Icon icon={Minus} size="sm" sx={{ color: 'text.disabled' }} />
        }
    </>
}
